import { api } from '$utils/apiRequester'

export const LOAD_PROJECT_REQUEST = 'LOAD_PROJECT_REQUEST'
export const LOAD_PROJECT_SUCCESS = 'LOAD_PROJECT_SUCCESS'
export const LOAD_PROJECT_FAILURE = 'LOAD_PROJECT_FAILURE'

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST'
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS'
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE'

export const UPDATE_PARTNERSHIP_REQUEST = 'UPDATE_PARTNERSHIP_REQUEST'
export const UPDATE_PARTNERSHIP_SUCCESS = 'UPDATE_PARTNERSHIP_SUCCESS'
export const UPDATE_PARTNERSHIP_FAILURE = 'UPDATE_PARTNERSHIP_FAILURE'

export const UPDATE_PROJECT_MANAGER_TYPE_REQUEST = 'UPDATE_PROJECT_MANAGER_TYPE_REQUEST'
export const UPDATE_PROJECT_MANAGER_TYPE_SUCCESS = 'UPDATE_PROJECT_MANAGER_TYPE_SUCCESS'
export const UPDATE_PROJECT_MANAGER_TYPE_FAILURE = 'UPDATE_PROJECT_MANAGER_TYPE_FAILURE'

export const UPDATE_PROJECT_NOTE_REQUEST = 'UPDATE_PROJECT_NOTE_REQUEST'
export const UPDATE_PROJECT_NOTE_SUCCESS = 'UPDATE_PROJECT_NOTE_SUCCESS'
export const UPDATE_PROJECT_NOTE_FAILURE = 'UPDATE_PROJECT_NOTE_FAILURE'

export const LOAD_PROJECT_PARTNERSHIPS_REQUEST = 'LOAD_PROJECT_PARTNERSHIPS_REQUEST'
export const LOAD_PROJECT_PARTNERSHIPS_SUCCESS = 'LOAD_PROJECT_PARTNERSHIPS_SUCCESS'
export const LOAD_PROJECT_PARTNERSHIPS_FAILURE = 'LOAD_PROJECT_PARTNERSHIPS_FAILURE'

export const LOAD_PARTNERS_REQUEST = 'LOAD_PARTNERS_REQUEST'
export const LOAD_PARTNERS_SUCCESS = 'LOAD_PARTNERS_SUCCESS'
export const LOAD_PARTNERS_FAILURE = 'LOAD_PARTNERS_FAILURE'

export const ADD_PARTNERSHIP_REQUEST = 'ADD_PARTNERSHIP_REQUEST'
export const ADD_PARTNERSHIP_SUCCESS = 'ADD_PARTNERSHIP_SUCCESS'
export const ADD_PARTNERSHIP_FAILURE = 'ADD_PARTNERSHIP_FAILURE'

export const DELETE_PARTNERSHIP_REQUEST = 'DELETE_PARTNERSHIP_REQUEST'
export const DELETE_PARTNERSHIP_SUCCESS = 'DELETE_PARTNERSHIP_SUCCESS'
export const DELETE_PARTNERSHIP_FAILURE = 'DELETE_PARTNERSHIP_FAILURE'

export const BATCH_PARTNERSHIP_ACTIONS_REQUEST = 'BATCH_PARTNERSHIP_ACTIONS_REQUEST'
export const BATCH_PARTNERSHIP_ACTIONS_SUCCESS = 'BATCH_PARTNERSHIP_ACTIONS_SUCCESS'
export const BATCH_PARTNERSHIP_ACTIONS_FAILURE = 'BATCH_PARTNERSHIP_ACTIONS_FAILURE'

export const MARK_PROJECT_AS_READ_REQUEST = 'MARK_PROJECT_AS_READ_REQUEST'
export const MARK_PROJECT_AS_READ_SUCCESS = 'MARK_PROJECT_AS_READ_SUCCESS'
export const MARK_PROJECT_AS_READ_FAILURE = 'MARK_PROJECT_AS_READ_FAILURE'

export const MODERATE_PROJECT_REQUEST = 'MODERATE_PROJECT_REQUEST'
export const MODERATE_PROJECT_SUCCESS = 'MODERATE_PROJECT_SUCCESS'
export const MODERATE_PROJECT_FAILURE = 'MODERATE_PROJECT_FAILURE'

export const SUBMIT_PROJECT_REQUEST = 'SUBMIT_PROJECT_REQUEST'
export const SUBMIT_PROJECT_SUCCESS = 'SUBMIT_PROJECT_SUCCESS'
export const SUBMIT_PROJECT_FAILURE = 'SUBMIT_PROJECT_FAILURE'

export const COMPUTE_EXAMPLES_PROJECT_REQUEST = 'COMPUTE_EXAMPLES_PROJECT_REQUEST'
export const COMPUTE_EXAMPLES_PROJECT_SUCCESS = 'COMPUTE_EXAMPLES_PROJECT_SUCCESS'
export const COMPUTE_EXAMPLES_PROJECT_FAILURE = 'COMPUTE_EXAMPLES_PROJECT_FAILURE'

export const EDIT_DELIVERY_REQUEST = 'EDIT_DELIVERY_REQUEST'
export const EDIT_DELIVERY_SUCCESS = 'EDIT_DELIVERY_SUCCESS'
export const EDIT_DELIVERY_FAILURE = 'EDIT_DELIVERY_FAILURE'

export const UPDATE_PROJECT_PROPS = 'UPDATE_PROJECT_PROPS'

export const loadProject = (id, extraFields = [], isAuthenticated = true, params = {}) => {
  let fields = ''
  let queryString = ''

  if (extraFields && extraFields.length > 0) {
    fields = extraFields.join(',')
  }

  if (fields !== '') {
    params['extra_fields'] = fields
  }

  if (Object.keys(params).length > 0) {
    queryString = Object.entries(params)
      .map((value) => {
        return encodeURIComponent(value[0]) + '=' + encodeURIComponent(value[1])
      })
      .join('&')
  }

  if (queryString !== '') {
    queryString = `?${queryString}`
  }

  return {
    types: [LOAD_PROJECT_REQUEST, LOAD_PROJECT_SUCCESS, LOAD_PROJECT_FAILURE],
    promise: () =>
      api('ulule').get(`/projects/${id}${queryString}`, {
        withAccessToken: isAuthenticated,
      }),
  }
}

export const updateProject = (id, params, extraFields = []) => ({
  types: [UPDATE_PROJECT_REQUEST, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAILURE],
  promise: () =>
    api('ulule').patch(
      `/projects/${id}${extraFields.length > 0 ? `?extra_fields=${extraFields.join(',')}` : ''}`,
      {
        body: {
          ...params,
        },
      },
      { withAccessToken: true }
    ),
})

export const updateProjectNote = (id, params, extraFields = []) => ({
  types: [UPDATE_PROJECT_NOTE_REQUEST, UPDATE_PROJECT_NOTE_SUCCESS, UPDATE_PROJECT_NOTE_FAILURE],
  promise: () =>
    api('ulule').patch(
      `/projects/${id}${extraFields.length > 0 ? `?extra_fields=${extraFields.join(',')}` : ''}`,
      {
        body: {
          ...params,
        },
      },
      { withAccessToken: true }
    ),
})

export const updateProjectManagerType = (id, type, extraFields = []) => ({
  types: [
    UPDATE_PROJECT_MANAGER_TYPE_REQUEST,
    UPDATE_PROJECT_MANAGER_TYPE_SUCCESS,
    UPDATE_PROJECT_MANAGER_TYPE_FAILURE,
  ],
  promise: () =>
    api('ulule').patch(
      `/projects/${id}${extraFields.length > 0 ? `?extra_fields=${extraFields.join(',')}` : ''}`,
      {
        body: {
          manager_type: type,
        },
      },
      { withAccessToken: true }
    ),
})

export const loadProjectPartnerships = (id) => ({
  types: [LOAD_PROJECT_PARTNERSHIPS_REQUEST, LOAD_PROJECT_PARTNERSHIPS_SUCCESS, LOAD_PROJECT_PARTNERSHIPS_FAILURE],
  promise: () =>
    api('ulule').get(`/projects/${id}/partnerships`, {
      withAccessToken: true,
    }),
})

export const addPartnership = (projectId, partnerId) => ({
  types: [ADD_PARTNERSHIP_REQUEST, ADD_PARTNERSHIP_SUCCESS, ADD_PARTNERSHIP_FAILURE],
  promise: () =>
    api('ulule').post(`/projects/${projectId}/partnerships`, {
      withAccessToken: true,
      body: {
        partner_id: parseInt(partnerId, 10),
      },
    }),
})

export const deletePartnership = (partnershipId) => ({
  types: [DELETE_PARTNERSHIP_REQUEST, DELETE_PARTNERSHIP_SUCCESS, DELETE_PARTNERSHIP_FAILURE],
  promise: () =>
    api('ulule').delete(`/partnerships/${partnershipId}`, {
      withAccessToken: true,
    }),
})

export const batchPartnershipActions = (projectId, partnersToAdd = [], partnershipsToDelete = []) => ({
  types: [BATCH_PARTNERSHIP_ACTIONS_REQUEST, BATCH_PARTNERSHIP_ACTIONS_SUCCESS, BATCH_PARTNERSHIP_ACTIONS_FAILURE],
  promise: (dispatch) => {
    const additions = partnersToAdd.map((partner) => dispatch(addPartnership(projectId, partner.id)))
    const deletions = partnershipsToDelete.map((partnership) => dispatch(deletePartnership(partnership.id)))

    return Promise.all([...additions, ...deletions]).then(() => {
      dispatch(loadProjectPartnerships(projectId))
    })
  },
})

export const updatePartnership = (partnerId, params) => ({
  types: [UPDATE_PARTNERSHIP_REQUEST, UPDATE_PARTNERSHIP_SUCCESS, UPDATE_PARTNERSHIP_FAILURE],
  promise: () =>
    api('ulule').patch(
      `/partnerships/${partnerId}`,
      {
        body: {
          ...params,
        },
      },
      { withAccessToken: true }
    ),
})

export const markProjectAsRead = (projectId) => ({
  types: [MARK_PROJECT_AS_READ_REQUEST, MARK_PROJECT_AS_READ_SUCCESS, MARK_PROJECT_AS_READ_FAILURE],
  promise: () =>
    api('ulule').patch(
      `/projects/${projectId}`,
      {
        body: {
          unread: false,
        },
      },
      { withAccessToken: true }
    ),
})

export const moderateProject = (projectId, body) => ({
  types: [MODERATE_PROJECT_REQUEST, MODERATE_PROJECT_SUCCESS, MODERATE_PROJECT_FAILURE],
  promise: () =>
    api('ulule').post(`/projects/${projectId}/moderate?extra_fields=manager,answer_code`, {
      body,
      withAccessToken: true,
    }),
  data: {
    ...body,
    id: projectId,
  },
})

export const submitProject = (projectId, body) => ({
  types: [SUBMIT_PROJECT_REQUEST, SUBMIT_PROJECT_SUCCESS, SUBMIT_PROJECT_FAILURE],
  promise: () => api('ulule').post(`/projects/${projectId}/submit`, { body, withAccessToken: true }),
})

export const computeExamples = (projectId, body) => ({
  types: [COMPUTE_EXAMPLES_PROJECT_REQUEST, COMPUTE_EXAMPLES_PROJECT_SUCCESS, COMPUTE_EXAMPLES_PROJECT_FAILURE],
  promise: () =>
    api('ulule').post(`/projects/${projectId}/compute-examples`, {
      body,
      withAccessToken: true,
    }),
})

export const editDelivery = (projectId, body) => ({
  types: [EDIT_DELIVERY_REQUEST, EDIT_DELIVERY_SUCCESS, EDIT_DELIVERY_FAILURE],
  promise: () =>
    api('ulule').patch(
      `/projects/${projectId}/delivery`,
      {
        body,
      },
      { withAccessToken: true }
    ),
})

export const updateProjectProps = (props) => {
  return {
    type: UPDATE_PROJECT_PROPS,
    props,
  }
}
